import { ReactNode } from 'react'
import { useSubscription } from '@/hooks/useSubscription'
import UpgradePrompt from './UpgradePrompt'

type FeatureKey =
  | 'finance'
  | 'attendance'
  | 'advancedMinistry'
  | 'completeFinance'
  | 'qrAttendance'
  | 'ministryScheduling'
  | 'hrPayroll'
  | 'mediaLibrary'
  | 'mobileApp'
  | 'apiAccess'
  | 'multiLocation'

interface FeatureGateProps {
  feature: FeatureKey
  churchId: string | null | undefined
  children: ReactNode
  fallback?: ReactNode
}

export default function FeatureGate({ feature, churchId, children, fallback }: FeatureGateProps) {
  const { features, loading } = useSubscription(churchId)

  // While loading, show children to avoid flash
  if (loading) return <>{children}</>

  // If feature is enabled, show children
  if (features[feature]) return <>{children}</>

  // Otherwise show fallback or upgrade prompt
  return <>{fallback || <UpgradePrompt feature={feature} />}</>
}
